<!-- 创建时间2023/07/03 17:04:58 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：关键点标记 -->
<template>
  <yxt-drawer :title="$t('pc_kng_mark_lbl_key_mark'/** 关键点标记 */)" size="960px" custom-class="yxtbiz-kng-point" :visible.sync="visible">
    <div class="yxtbiz-flex yxtbiz-kng-point__main">
      <div class="yxtbiz-flex-1">
        <yxt-scrollbar :fit-height="true">
          <div class="pr24 pt24 pl24">
            <yxtbiz-video v-if="playerOptions.fileId"
              class="yxtbizf-br-4"
              v-bind="playerOptions"
              :marks="list"
              ref="player"
              width="100%"
              height="243px"
              @markJump="markJump"
              @onPlay="playing = true"
              @onTime="updateViewLoc"
              />
          </div>
          <yxt-tabs class="mt12" v-model="activeName">
            <yxt-tab-pane class="ph24 pb24" :label="$t('pc_biz_lbl_manualmark'/** 手动标记 */)" name="1">
              <form-point-form :form="form" :insert-disabled="insertDisabled"/>
              <yxt-button class="mt24" type="second" :disabled="!form.time || !form.desc" @click="add">{{ $t('pc_biz_btn_add'/** 添加 */) }}</yxt-button>
            </yxt-tab-pane>
            <yxt-tab-pane class="ph24 pb24" :label="$t('pc_kng_mark_btn_batch_mark'/** 批量标记 */)" name="2">
              <div class="yxtbiz-flex-center">
                {{ $t('pc_kng_mark_lbl_tag_content'/** 标记内容 */) }}
                <yxt-tooltip
                  max-width="400"
                  effect="dark"
                  placement="bottom"
                  :content="$t('pc_kng_upload_lbl_browse_allowtip' /*设置后即使无目录浏览权限也支持浏览*/)"
                >
                  <div slot="content">
                    {{ $t('pc_kng_mark_lbl_tag_content_desc1'/*1. 关键帧时间最大不能超出课件时长。*/) }}<br>
                    {{ $t('pc_kng_mark_lbl_tag_content_desc2'/*2. 关键帧至少从00:01开始标记。*/) }}<br>
                    {{ $t('pc_kng_mark_lbl_tag_content_desc3'/*3. 关键帧描述50字以内。*/) }}
                  </div>
                  <yxt-svg
                    class="hand v-mid color-gray-6 ml4"
                    width="16px"
                    height="16px"
                    icon-class="icons/question-cirlce-o"
                  />
                </yxt-tooltip>
              </div>
              <yxt-input
                class="mt8"
                type="textarea"
                :rows="10"
                :placeholder="$t('pc_kng_mark_msg_tag_example').replace(/\\r\\n/g, '\r\n')"
                show-word-limit
                v-model="batchText"/>
              <yxt-button class="mt24" type="second" :disabled="!batchText" @click="addBatch">{{ $t('pc_biz_btn_add'/** 添加 */) }}</yxt-button>
            </yxt-tab-pane>
            <yxt-tab-pane v-if="showAiPoints" class="ph24 pb8" :label="$t('pc_biz_btn_autoadd'/** 自动标记 */)" name="3">
              <div class="color-gray-7 text-center mt32" v-if="autoMarkList.length === 0">
                <yxt-empty :empty-text="$t('pc_biz_lbl_nopoints'/** 暂无关键点 */)"/>
                <div v-html="$t('pc_biz_lbl_automarktip')"></div>
              </div>
              <template v-else>
                <div ref="title" class="color-gray-7">{{ $t('pc_biz_lbl_selectautomark'/** 请选择以下关键点标记（标记是由AI字幕中自动提炼的主题） */) }}</div>
                <yxt-table 
                  ref="table"
                  class="mt16"
                  :max-height="maxHeight" 
                  :data="autoMarkList" 
                  row-key="id"
                  @selection-change="handleSelectionChange">
                  <yxt-table-column
                    type="selection"
                    :reserve-selection="true"
                    width="32">
                  </yxt-table-column>
                  <yxt-table-column
                    prop="markTime"
                    :label="$t('pc_kng_mark_btn_point_time'/** 时间点 */)"
                    width="120">
                    <template slot-scope="scope">
                      {{ getDurationFormat(scope.row.markTime) }}
                    </template>
                  </yxt-table-column>
                  <yxt-table-column
                    prop="markDesc"
                    :label="$t('pc_biz_udp_lbl_description'/** 描述 */)">
                  </yxt-table-column>
                </yxt-table>
                <yxt-button class="mt16" type="second" :disabled="!autoSelected.length" @click="addAuto">{{ $t('pc_biz_btn_add'/** 添加 */) }}</yxt-button>
              </template>
              
            </yxt-tab-pane>
          </yxt-tabs> 
    
        </yxt-scrollbar>
      </div>
      <div class="yxtbiz-flex-1">
        <div class="mt24 ph24">{{ $t('pc_biz_lbl_marknumber', [list.length]) }}</div>
        <div class="yxtbiz-kng-point__list-main">
          <yxt-scrollbar :fit-height="true">
            <div class="ph24">
              <form-point-cell 
                v-for="(item,index) in list" 
                :key="index" 
                :cell-data="item"
                :is-edit="item === current"
                @change="change"
                @save="save"
                @delete="del(index)"/>
            </div>
          </yxt-scrollbar>
        </div>
      </div>
    </div>
    <div slot="footer">
      <yxt-button plain @click="cancel">{{ $t('pc_biz_comment_cancel'/** 取消 */) }}</yxt-button>
      <yxt-button type="primary" @click="confirm">{{ $t('pc_biz_common_btn_sure'/** 确定 */) }}</yxt-button>
    </div>
  </yxt-drawer>
</template>

<script>
import { getDurationFormat } from 'yxt-biz-pc/packages/kng-operator/utils';
import { getPlayInfo, getPointOfAI } from 'yxt-biz-pc/packages/kng-operator/service';
import { KNG_TYPE } from 'yxt-biz-pc/packages/select-kng/src/const';
import formPointForm from './form-point-form.vue';
import formPointCell from './form-point-cell.vue';
import { uuid } from 'yxt-biz-pc/packages/upload/src/utils';
export default {
  name: 'form-point-drawer',
  inject: ['getShowAiPoints'],
  props: {
    kngId: {
      type: String,
      default: ''
    },
    fileId: {
      type: String,
      default: ''
    }
  },
  provide() {
    return {
      getLoc: () => this.loc,
      getDuration: () => this.duration
    };
  },
  components: {
    formPointForm,
    formPointCell
  },
  data() {
    return {
      visible: false,
      list: [],
      playerOptions: {},
      activeName: '',
      loc: 0,
      form: {
        time: 0,
        desc: ''
      },
      batchText: '',
      autoSelected: [],
      playing: false,
      autoMarkList: [],
      current: null,
      maxHeight: 0
    };
  },
  computed: {
    duration() {
      if (this.playing) {
        return Math.floor(this.$refs.player.getPlayer().getDuration());
      }
      return 0;
    },
    insertDisabled() {
      return !this.playing || this.loc === 0;
    },
    showAiPoints() {
      return this.getShowAiPoints();
    }
  },
  watch: {
    activeName(val) {
      if (val === '3') this.setTableMaxHeight();
    }
  },
  methods: {
    getDurationFormat,
    init(list = []) {
      return new Promise(async(resolve, reject) => {
        const params = {
          kngId: this.kngId,
          studyParam: {
            originOrgId: '',
            previewType: 1
          },
          targetCode: 'kng',
          targetId: ''
        };
        getPlayInfo(params)
          .then(res => {
            const {playDetails, envFlag} = res;
            const options = (playDetails || []).map(item => {
              return {
                fileFullUrl: item.url,
                resolution: item.desc,
                fileId: res.fileId
              };
            });
            // 获取播放
            this.playerOptions = {
              fileId: res.fileId,
              type: res.kngType === KNG_TYPE.AUDIO ? 'audio' : 'video',
              isNeedToken: envFlag !== 0 && !res.specialMode, // 非三方课的公有云音视频需要解密
              isShowWatermark: false,
              controlbarDrag: true,
              options: res.kngType === KNG_TYPE.AUDIO ? options.slice(0, 1) : options // 音频取一个
            };
            this.list = [...list];
            this.resolve = resolve;
            this.reject = reject;
            this.activeName = '1';
            this.getAutoMarkList();
            this.visible = true;
          })
          .catch(e => {
            const msg = e && e.error && e.error.message;
            this.$message.error(msg);
          });
      });
    },
    async getAutoMarkList() {
      const res = await getPointOfAI(this.kngId, this.fileId);
      this.autoMarkList = res && res.pointInfoList || [];
    },
    cancel() {
      this.visible = false;
      this.reject(new Error('cancel'));
    },
    confirm() {
      if (this.current) {
        return this.$message.warning(this.$t('pc_biz_msg_savepointinfo'/** 请先保存关键点信息！*/));
      }
      this.visible = false;
      this.resolve(this.list);
    },
    updateViewLoc(e) {
      this.loc = Math.floor(e.position);
    },
    markJump(time) {
      this.$refs.player && this.$refs.player.seek(time);
    },
    // 单个增加
    add() {
      const {time, desc} = this.form;
      this.addNewList([{markDesc: desc, markTime: time, _id: uuid()}]);
      this.form = {time: 0, desc: ''};
    },
    // 批量增加
    addBatch() {
      // 处理\校验用户输入的批量打点的数据
      const reg = /[\n]{2,}/g;
      const arr = this.batchText && this.batchText.trim().replace(reg, '\n');
      const list = arr.split(/\n/).map(item => {
        return item && item.trim();
      });
      // 如果用户输入的时间点和描述不匹配
      if (list.length % 2) {
        list.push('');
      }
      const result = [];
      for (let i = 0; i < list.length / 2; i++) {
        let obj = {};
        const time = list[2 * i];
        const desc = list[2 * i + 1];
        const reg = /\d{2}:\d{2}(:\d{2}){0,1}/;
        if (!reg.test(time)) {
          return this.$message.warning(this.$t('pc_kng_mark_tip_timeformat_notconform'/* '时间格式不符合规则' */));
        } else if (time === '00:00' || time === '00:00:00') {
          return this.$message.warning(this.$t('pc_kng_mark_tip_keymark_from'/* '关键点至少从00:01开始标记' */));
        }
        const timeArr = time.split(':').reverse();
        const seconds = ~~timeArr[0];
        const minutes = ~~timeArr[1];
        const hours = timeArr.length > 2 ? ~~timeArr[2] : 0;
        obj.markTime = hours * 60 * 60 + minutes * 60 + seconds;
        if (obj.markTime > this.duration) {
          return this.$message.warning(this.$t('pc_kng_mark_msg_notexceed_courseware_duration'/* '关键点时间不能超出课件时长' */));
        } else if (!desc) {
          return this.$message.warning(this.$t('pc_kng_mark_tip_keydesc_notempty'/* '关键点描述不能为空' */));
        } else if (desc.length > 50) {
          return this.$message.warning(this.$t('pc_kng_mark_tip_keypoint_notexceed_50words'/* '关键点描述不能超出50字' */));
        }
        obj.markDesc = desc;
        obj._id = uuid();
        result.push(obj);
      }
      this.addNewList(result);
      this.batchText = '';
    },
    // 自动提炼的添加
    addAuto() {
      const result = this.autoSelected.map(item => ({...item, _id: uuid()}));
      this.addNewList(result);
      this.$refs.table.clearSelection();
    },
    change(item) {
      if (this.current && item) {
        return this.$message.warning(this.$t('pc_biz_msg_savepointinfo'/** 请先保存关键点信息！*/));
      }
      this.current = item;
      this.sort();
    },
    save(obj) {
      const index = this.list.findIndex(item => item._id !== obj._id && item.markTime === obj.markTime);
      if (index > -1) {
        this.list.splice(index, 1);
        this.$message.warning(this.$t('pc_kng_mark_msg_cover_mark'/** 同一时间点标记存在重复项，已被自动覆盖 */));
      }
    },
    del(index) {
      this.list.splice(index, 1);
    },
    sort() {
      this.list = this.list.sort((a, b) => a.markTime - b.markTime);
    },
    setTableMaxHeight() {
      const textHeight = this.$refs.title && this.$refs.title.offsetHeight || 0;
      this.maxHeight = window.innerHeight - 564 - textHeight;
    },
    handleSelectionChange(val) {
      this.autoSelected = val;
    },
    addNewList(targetList) {
      let hasRepeat = false;
      targetList.forEach(obj => {
        const index = this.list.findIndex(item => item.markTime === obj.markTime && item._id !== obj._id);
        if (index > -1) {
          hasRepeat = true;
          this.list.splice(index, 1);
        }
        this.list.push(obj);
      });
      if (hasRepeat) {
        this.$message.warning(this.$t('pc_kng_mark_msg_cover_mark'/** 同一时间点标记存在重复项，已被自动覆盖 */));
      }
      this.sort();
    }
  }
};
</script>